<template>
  <div
    class="runner-action"
    :class="`runner-action--${direction}`"
  >
    <q-icon
      class="arrow"
      :name="direction === 'pickoff' ? 'sports_baseball' : 'west'"
      size="12px"
    />

    <q-icon
      class="runner"
      :name="direction === 'pickoff' ? 'north_east' : 'directions_run'"
      size="18px"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  direction: 'pickoff' | 'steal'
}>()
</script>

<style scoped>
.runner-action {
  display: inline-flex;
  align-items: center;
  line-height: 1;
}

.runner-action .arrow {
  margin-right: -2px;
  z-index: 2;
}

.runner-action .runner {
  z-index: 1;
}
</style>
